module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_22.823758e2.pdf";